import { Breadcrumb } from 'antd';
import Link from 'next/link';
import { FC } from 'react';
import styles from './CustomBreadcrumb.module.scss';
import { CustomBreadcrumbProps } from './CustomBreadcrumb.props';

const CustomBreadcrumb: FC<CustomBreadcrumbProps> = ({ items }) => {
  const breadcrumbItems = items.length
    ? items.map((item) => ({
        key: item.slug,
        title: <Link href={item.href}>{item.title}</Link>,
        className: styles.containerItem,
      }))
    : [
        {
          key: 'home',
          title: <Link href="/">Home</Link>,
          className: styles.containerItem,
        },
      ];

  return <Breadcrumb className={styles.container} items={breadcrumbItems} />;
};

export { CustomBreadcrumb };
